var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMascotSmall2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "4 4 44 44",
    fill: "#E48A99",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_74_24546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 48C38.1503 48 48 38.1503 48 26C48 13.8497 38.1503 4 26 4C13.8497 4 4 13.8497 4 26C4 38.1503 13.8497 48 26 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 48C38.1503 48 48 38.1503 48 26C48 13.8497 38.1503 4 26 4C13.8497 4 4 13.8497 4 26C4 38.1503 13.8497 48 26 48Z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6397 35.9795C34.8372 36.1081 34.9802 36.3005 35.0426 36.5218C35.1051 36.7431 35.0828 36.9786 34.9799 37.1855C34.877 37.3924 34.7003 37.5569 34.4818 37.6492C34.2634 37.7415 34.0178 37.7554 33.7896 37.6885L27.8356 36.0534C27.6783 36.0454 27.5272 35.9912 27.4029 35.8982C27.2785 35.8051 27.1868 35.6777 27.1401 35.5331C27.0927 35.2123 27.4721 34.7795 28.0691 34.7902V27.9825C26.8212 28.2456 25.5295 28.2512 24.2793 27.9991V37.8377L27.3724 39.2489C27.5701 39.3775 27.7133 39.57 27.7758 39.7915C27.8383 40.0129 27.816 40.2485 27.713 40.4555C27.6099 40.6625 27.433 40.8271 27.2144 40.9193C26.9957 41.0115 26.7499 41.0252 26.5216 40.9579L20.5701 39.3229C20.4127 39.3149 20.2616 39.2607 20.1371 39.1677C20.0127 39.0746 19.9209 38.9472 19.874 38.8026C19.8266 38.4817 20.2061 38.049 20.8036 38.0596V34.567C20.8036 33.2753 20.8036 26.8389 20.8036 26.4914C19.2976 25.4164 18.1815 23.9136 17.6133 22.1955C17.0452 20.4775 17.0537 18.6312 17.6377 16.918C18.2217 15.2049 19.3516 13.7116 20.8674 12.6495C22.3833 11.5875 24.2084 11.0105 26.0844 11.0001C27.9604 10.9898 29.7922 11.5467 31.3207 12.592C32.8491 13.6372 33.9968 15.118 34.6012 16.8246C35.2056 18.5312 35.2361 20.3773 34.6885 22.1015C34.1408 23.8257 33.0428 25.3407 31.5497 26.4322V34.5653L34.6397 35.9795ZM33.0854 16.4084L32.9185 15.5115L32.2205 14.8396L24.0113 14.3767L23.3201 14.9154L23.0238 15.933L26.7379 22.9691L27.5904 23.2752L28.602 23.0171L33.0854 16.4084Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0651 19.9309C29.2607 19.9309 30.2299 18.9995 30.2299 17.8507C30.2299 16.7018 29.2607 15.7705 28.0651 15.7705C26.8696 15.7705 25.9004 16.7018 25.9004 17.8507C25.9004 18.9995 26.8696 19.9309 28.0651 19.9309Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_74_24546",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.362353 0 0 0 0 0.418353 0 0 0 0 0.54902 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_74_24546"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_74_24546",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotSmall2);
export default __webpack_public_path__ + "static/media/mascot_small_2.2a7c19500e5d438e42049d8aca55b15d.svg";
export { ForwardRef as ReactComponent };